export const AUTH_LOADING = "auth/loading";
export const AUTH_ERROR = "auth/error";

export const USER_LOGIN = "user/login";
export const USER_LOGOUT = "user/logout";
export const ADMIN_LOGIN = "admin/login";
export const ADMIN_LOGOUT = "admin/logout";
export const RESET_LOGIN = "user/reset";

export const GET_USER_DETAILS = "user/reset";
